module.exports = __webpack_public_path__ + "img/gh-36204-2.prt.a8241c37.jpg";